<template>
  <div class="container">
    <v-data-table
      :headers="headerFields"
      :items="tareas"
      class="elevation-2"
      :no-data-text="gnodata"
      dense
      :items-per-page="10"
    >
      <template v-slot:item.fechamodificacion="{ item }">{{formato(item.fechamodificacion)}}</template>
      <template v-slot:item.idusuarioresponsable="{ item }">{{usuario(item.idusuarioresponsable)}}</template>
      <template v-slot:item.observacion="{item}">
        <div v-html="cambiarenter(item.observacion)"></div>
      </template>
      <template v-slot:item.idestado="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <div>
              <v-icon large class="mr-2" :color="color(item)" v-on="on">info</v-icon>
            </div>
          </template>
          <span>{{estado(item)}}</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import store from "../../stores/index.js";
import moment from "moment";
export default {
  name: "historico",
  props: {
    idtabla: Number,
    idelemento: Number,
  },
  data() {
    return {
      tareas: [],
      cargando: true,
      headerFields: [
        {
          value: "fechamodificacion",
          text: "Fecha",
          width: "15%",
        },
        {
          value: "idestado",
          text: "Estado",
          align: "center",
          width: 100,
        },
        {
          value: "idusuarioresponsable",
          text: "Usuario",
          width: "20%",
        },
        {
          value: "observacion",
          text: "Observación",
        },
      ],
      //Parametros de paginación

    };
  },
  methods: {
    ...mapActions(["get_historicotareas", "get_estados"]),
    ...mapActions("usuario/", ["get_usuarios"]),
    usuario(idusuario) {
      if (this.gusuarios !== undefined)
        return this.gusuarios.filter((p) => p.idusuario === idusuario)[0].login;
      else return "Anonimo";
    },
    cambiarenter(cadena) {
      if (cadena !== null) {
        let otro = cadena.replace(/\n/g, "<br>");
        return otro;
      }
    },
    formato(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY (HH:mm)");
      }
    },
    color(item) {
      if (this.gestados.length > 0) {
        if (item.idestado !== 0) {
          return this.gestados.filter((p) => p.idestado === item.idestado)[0]
            .color;
        } else {
          return "gray";
        }
      } else {
        store.watch(
          () => store.getters["gestados"],
          () => {
            return this.gestados.filter((p) => p.idestado === item.idestado)[0]
              .color;
          }
        );
      }
    },
    estado(item) {
      if (this.gestados.length > 0) {
        if (item.idestado !== 0) {
          return this.gestados.filter((p) => p.idestado === item.idestado)[0]
            .nombre;
        } else {
          return "Procesando";
        }
      } else {
        store.watch(
          () => store.getters["gestados"],
          () => {
            return this.gestados.filter((p) => p.idestado === item.idestado)[0]
              .nombre;
          }
        );
      }
    },
  },
  computed: {
    ...mapGetters(["gestados", "gtareascerradas"]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
    ...mapGetters("usuario", ["gusuario", "gusuarios"]),
  },
  created() {
    this.get_estados();
    this.get_usuarios();
    this.get_historicotareas({
      params: {
        idtabla: this.idtabla,
        idelemento: this.idelemento,
      },
    });
  },
  mounted() {
  },
  watch: {
    gtareascerradas: function () {
      this.cargando = false;
      this.tareas = this.gtareascerradas.filter(
        (p) => p.idaccionNavigation.visible === true
      );
    },
  }
};
</script>
